import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import Alert from 'react-bootstrap/Alert';

const Result = () => {
    return (
        <Alert variant="success" className="success-msg">
        Your Meeting has been scheduled successfully.
        </Alert>
    )
}

const Meetingform = () => {

    const form = useRef();

    const [ result, showresult ] = useState(false);

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_chhqqaq', 'template_wnad8m5', form.current, 'TQrYqWZE-bL1cJYAA')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
          form.current.reset();
          showresult(true);
      };

        setTimeout(() => {
            showresult(false);
        }, 5000);

    return (
        <form className="axil-contact-form" ref={form} onSubmit={sendEmail}>
        <div className="form-group">
            <label>Name</label>
            <input type="text" className="form-control" name="contact-name" placeholder="John Smith" required />
        </div>
        <div className="form-group">
            <label>Email</label>
            <input type="email" className="form-control" name="contact-email" placeholder="example@mail.com" required />
        </div>
        <div className="form-group">
            <label>Phone</label>
            <input type="tel" className="form-control" name="contact-phone" placeholder="+123456789" required />
        </div>
        <div className="form-group mb--40">
            <label>Choose Date and Time</label>
            <input type='datetime-local' className="form-control" name="contact-meeting" required />
        </div>
        <div className="form-group">
            <button type="submit" className="axil-btn btn-fill-primary btn-fluid btn-primary" name="submit-btn">Schedule Meeting</button>
        </div>
        <div className="form-group">
            {result ? <Result /> : null}
        </div>
    </form>
    )
}

export default Meetingform;